// theme
import { PaletteColorOptions } from '@mui/material';
import palette from '../../theme/palette';
//
import { ThemeColorPresetsValue } from './types';

export const presets = (
  theme: 'light' | 'dark',
): (PaletteColorOptions & { name: string })[] => {
  const themePalette: any = palette(theme);

  return [
    // DEFAULT
    {
      name: 'default',
      ...themePalette.primary,
    },
    // COLLABORATE
    {
      name: 'collaborate',
      lighter: themePalette.collaborate[100],
      light: themePalette.collaborate[300],
      main: themePalette.collaborate[500],
      dark: themePalette.collaborate[700],
      darker: themePalette.collaborate[900],
      contrastText: '#FFFFFF',
    },
    // COMMUNICATE
    {
      name: 'communicate',
      lighter: themePalette.communicate[100],
      light: themePalette.communicate[300],
      main: themePalette.communicate[500],
      dark: themePalette.communicate[700],
      darker: themePalette.communicate[900],
      contrastText: '#FFFFFF',
    },
    // AI
    {
      name: 'ai',
      lighter: themePalette.grey[100],
      light: themePalette.grey[300],
      main: themePalette.grey[500],
      dark: themePalette.grey[700],
      darker: themePalette.grey[900],
      contrastText: '#FFFFFF',
    },
  ];
};

export const defaultPreset = (theme: 'light' | 'dark') => presets(theme)[0];

export const presetsOption = (theme: 'light' | 'dark') =>
  presets(theme).map((color: any) => ({
    name: color.name,
    value: color.main,
  }));

export function getPresets(
  key: ThemeColorPresetsValue,
  theme: 'light' | 'dark',
) {
  return (
    {
      default: defaultPreset(theme),
      collaborate: presets(theme)[1],
      communicate: presets(theme)[2],
      ai: presets(theme)[3],
    }[key] || defaultPreset(theme)
  );
}
